import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const router = [
    {
        path: '/',
        redirect: '/operate'
  },
  {
    path: '/single',
    component:()=>import('../views/single.vue')
},
    {
      path: '/login',
      name: 'login',
      meta: {       
		authCheck: false
      },
      component: () => import('@/views/platm/login'),
     
    },    
    {
      path: '/main',
      name: 'main',
      meta: {       
        keepAlive: true
      },
      component: () => import('@/views/platm/main'),
     
    },  
    {
        path: '/operate',
        name: 'operate',
        component: () => import('@/views/operate/index1'),
        meta: {
          title:"歌莉娅运营数据看板",
		  roles: ['kanban:operate'],
          keepAlive: false
        }
    },
    {
      path: '/vip',
      name: 'vip',
      component: () => import('@/views/vip/index'),
      meta: {
        keepAlive: true
      }
   },
   {
    path: '/vip2',
    name: 'vip2',
    component: () => import('@/views/vip2/index'),
    meta: {
		title:'歌莉娅会员分析看板',
		roles: ['kanban:vip'],
		keepAlive: false
    }
  },
   
  // 有页头
  {
    path: '/platm',
    name: 'platm',
    component: ()=>import('@/views/platm/index'),
    children: [
      {
        path: 'Multiple',
        component:()=>import('../views/Multiple.vue')
      },
      {
        path: 'vip11',
        name: 'vip11',
        component: () => import('@/views/vip2/index11'),
        meta: {
        title:'歌莉娅会员分析看板',
        roles: ['kanban:vip'],
        keepAlive: false
        }
      },
      {
        path: 'operate11',
        name: 'operate11',
        component: () => import('@/views/operate/index11'),
        meta: {
          title:"歌莉娅运营数据看板",
      roles: ['kanban:operate'],
          keepAlive: false
        }
      },
      {
        path: 'bottom',
        name: 'bottom',
        meta:{
			title:"BOTTOM数据看板",
			roles: ['kanban:bottom']
        },
        component: ()=>import('@/views/platm/bottom/index')
      },
      {
        path: 'bigop/:id',
        name:'bigop',
        meta:{
			title:"歌莉娅大店运营看板",
			roles: ['kanban:bigop']
        },
        component: ()=>import('@/views/platm/bigoperation/index')
      },
      {
        path: 'design',
        name: 'design',
        meta:{
			title:"歌莉娅设计研发看板",
			roles: ['kanban:design']
        },
        component: ()=>import('@/views/platm/design/index')
      },
      {
        path: 'supply',
        name: 'supply',
        meta:{
			title:"供应链数据分析看板",
			roles: ['kanban:supply']
        },
        component: ()=>import('@/views/platm/supply/index')
      },
      {
        path: 'digitalproduction_1',
        name: 'digitalproduction_1',
        meta:{
			title:"歌莉娅数字化生产一",
			roles: ['kanban:production_1']
        },
        component: ()=>import('@/views/platm/digitalproduction_1/index')
      },
      {
        path: 'capacity',
        name: 'capacity',
        meta:{
			title:"本月个人产能排行",
        },
        component: ()=>import('@/views/platm/capacity/index')
      },
      {
        path: 'digitalproduction_2',
        name: 'digitalproduction_2',
        meta:{
			title:"歌莉娅数字化生产二",
			roles: ['kanban:production_2']
        },
        component: ()=>import('@/views/platm/digitalproduction_2/index')
      },
      {
        path:"production_schedule",
        name:"production_schedule",
        meta:{
			title:"歌莉娅新款进度看板",
			roles: ['kanban:schedule']
        },
        component:()=>import("@/views/platm/production_schedule/index")
      },
      {
        path:"marketing",
        name:"marketing",
        meta:{
			title:"新款上市销售监测",
			roles: ['kanban:marketing']
        },
        component:()=>import("@/views/platm/marketing/index")
      },
      {
        path:"quality_testing",
        name:"quality_testing",
        meta:{
			title:"歌莉娅质检看板",
			roles: ['kanban:quality']
        },
        component:()=>import("@/views/platm/quality_testing/index")
      },
      {
        path:"warehouse",
        name:"warehouse",
        meta:{
			title:"歌莉娅仓库看板",
			roles: ['kanban:warehouse']
        },
        component:()=>import("@/views/platm/warehouse/index")
      },
      {
        path:"online",
        name:"online",
        meta:{
			title:"歌莉娅线上运营看板",
			roles: ['kanban:online']
        },
        component:()=>import("@/views/platm/online/index")
      }
    ]
  },






  // 无页头
  {
    path: '/vip11',
    name: 'vip11',
    component: () => import('@/views/vip2/index11'),
    meta: {
		title:'歌莉娅会员分析看板',
		roles: ['kanban:vip'],
		keepAlive: false
    }
  },
  {
    path: '/operate11',
    name: 'operate11',
    component: () => import('@/views/operate/index11'),
    meta: {
      title:"歌莉娅运营数据看板",
  roles: ['kanban:operate'],
      keepAlive: false
    }
  },
  
      {
        path:'/bottom',
        name: 'bottom',
        meta:{
			title:"BOTTOM数据看板",
			roles: ['kanban:bottom']
        },
        component: ()=>import('@/views/platm/bottom/index')
      },
      {
        path:'/bigop/:id',
        name:'bigop',
        meta:{
			title:"歌莉娅大店运营看板",
			roles: ['kanban:bigop']
        },
        component: ()=>import('@/views/platm/bigoperation/index')
      },
      {
        path:'/design',
        name: 'design',
        meta:{
			title:"歌莉娅设计研发看板",
			roles: ['kanban:design']
        },
        component: ()=>import('@/views/platm/design/index')
      },
      {
        path:'/supply',
        name: 'supply',
        meta:{
			title:"供应链数据分析看板",
			roles: ['kanban:supply']
        },
        component: ()=>import('@/views/platm/supply/index')
      },
      {
        path:'/digitalproduction_1',
        name: 'digitalproduction_1',
        meta:{
			title:"歌莉娅数字化生产一",
			roles: ['kanban:production_1']
        },
        component: ()=>import('@/views/platm/digitalproduction_1/index')
      },
      {
        path: '/capacity',
        name: 'capacity',
        meta:{
			title:"本月个人产能排行",
        },
        component: ()=>import('@/views/platm/capacity/index')
      },
      {
        path:'/digitalproduction_2',
        name: 'digitalproduction_2',
        meta:{
			title:"歌莉娅数字化生产二",
			roles: ['kanban:production_2']
        },
        component: ()=>import('@/views/platm/digitalproduction_2/index')
      },
      {
        path:"/production_schedule",
        name:"production_schedule",
        meta:{
			title:"歌莉娅新款进度看板",
			roles: ['kanban:schedule']
        },
        component:()=>import("@/views/platm/production_schedule/index")
      },
      {
        path:"/marketing",
        name:"marketing",
        meta:{
			title:"新款上市销售监测",
			roles: ['kanban:marketing']
        },
        component:()=>import("@/views/platm/marketing/index")
      },
      {
        path:"/quality_testing",
        name:"quality_testing",
        meta:{
			title:"歌莉娅质检看板",
			roles: ['kanban:quality']
        },
        component:()=>import("@/views/platm/quality_testing/index")
      },
      {
        path:"/warehouse",
        name:"warehouse",
        meta:{
			title:"歌莉娅仓库看板",
			roles: ['kanban:warehouse']
        },
        component:()=>import("@/views/platm/warehouse/index")
      },
      {
        path:"/online",
        name:"online",
        meta:{
			title:"歌莉娅线上运营看板",
			roles: ['kanban:online']
        },
        component:()=>import("@/views/platm/online/index")
      }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
    // base: '/question-test2/',
    scrollBehavior: () => ({y: 0}),
    routes: router
  })

export default createRouter()